module.exports = __webpack_public_path__ + "static/media/training.c312eacd.jpg";